<script lang="ts" setup>
import BaseTag from './BaseTag.vue';

defineProps<{
  name?: string;
}>();
</script>

<template>
  <BaseTag
    :class="{ 'cursor-pointer': !!$attrs.onClick }"
    v-bind="$attrs"
  >
    {{ name }}
    <slot />
  </BaseTag>
</template>
